<script setup>
  import { defineEmits, defineProps, ref, computed, watch } from 'vue'

  import POKEMON_DATA from '../data/pokemon-base-data.json';

  import TypeBadge from './TypeBadge.vue';
  import PokemonIcon from "./PokemonIcon.vue";
  import Modal from "./Modal.vue"

  import { titleCase } from '@/utilities';

  const emit = defineEmits(['select']);

  const props = defineProps({
    chosenBasename: String,
  });

  const searchInput = ref(null);

  const showingModal = ref(false);
  const inputValue = ref('');
  const lastChosen = ref(props.chosenBasename ?? null);



  const results = computed(() => {
    var shortlist = [];
    if (inputValue.value.length){
      for (var p in POKEMON_DATA) {
        if (POKEMON_DATA[p].name.toLowerCase().indexOf(inputValue.value.toLowerCase()) == -1) {
          continue
        }
        if (shortlist.length > 10){
          break
        }

        shortlist.push(POKEMON_DATA[p])
        for (let form of Object.values(POKEMON_DATA[p].forms)){
          shortlist.push({
            ...form,
            name: POKEMON_DATA[p].name+' '+titleCase(form.name.split('-').slice(1).join(' '))
          })
        }

      }
    }
    return shortlist
  });


  watch(showingModal, (newVal)=>{
    if (newVal){
      window.setTimeout(()=>{
        searchInput.value.focus();
      }, 100);
    }
  })

  const select = (clickedPokemon, extraData) => {
    lastChosen.value = clickedPokemon
    emit('select', clickedPokemon, extraData)
    showingModal.value = false;
  }

  const showModal = () => {
    showingModal.value = true
  }

</script>

<template>
  <div>
    <slot name="button" :showModal="showModal">
      <div class="cursor-pointer hover:shadow-xl" @click="()=>{showModal()}">
        <slot name="chosen">
          <div class="flex items-center gap-4">
            <template v-if="lastChosen">
              <PokemonIcon :pokemon="lastChosen"/>
              <div class="grow">
                <div class="inline-block font-bold text-lg">{{lastChosen.name}}</div>
              </div>
            </template>
            <template v-else>
              <PokemonIcon/>
              <div class="grow">
                <div class="inline-block font-bold text-lg">Choose a Pokémon</div>
              </div>
            </template>
          </div>
        </slot>
      </div>
    </slot>

    <Modal
      v-if="showingModal"
      @close="()=>{showingModal = false}"
    >
      <input
        class="text-2xl rounded outline-primary border border-gray-300 dark:border-gray-800 dark:bg-gray-600 pl-8 pr-16 py-4"
        ref="searchInput"
        placeholder="Enter a Pokémon name..."
        v-model="inputValue"
      />
      <div class="grow max-h-[66vh] overflow-y-auto flex flex-col gap-4">
        <div
          v-for="(pokemon, p) in results" :key="p"
          class="flex items-center gap-4"
        >
          <PokemonIcon :pokemon="pokemon"/>
          <div class="grow flex flex-col gap-1">
            <div class="font-bold text-lg">{{ pokemon.name }}</div>
            <div class="flex gap-1">
              <TypeBadge class="text-sm font-normal" :typeId="pokemon.types[0]" />
              <TypeBadge class="text-sm font-normal" v-if="pokemon.types[1]" :typeId="pokemon.types[1]" />
            </div>
          </div>
          <slot name="controls" :pokemon="pokemon" :select="select">
            <div class="button bg-primary text-white hover:bg-primary-hover" @click="select(pokemon)">
              Select
            </div>
          </slot>
        </div>
      </div>
    </Modal>
  </div>
</template>
